export const Loader = {
  template: `
    <div class="dzen-chat-loader" :class="{ 'dzen-chat-loader--fullscreen': fullscreen }">
      <div class="dzen-chat-loader__content">
        <div class="dzen-chat-loader__spinner">
          <div class="dzen-chat-loader__bounce1"></div>
          <div class="dzen-chat-loader__bounce2"></div>
          <div class="dzen-chat-loader__bounce3"></div>
        </div>
        <div v-if="text" class="dzen-chat-loader__text">{{ text }}</div>
      </div>
    </div>
  `,
  props: {
    fullscreen: Boolean,
    text: String,
  },
}